import * as React from 'react'
import { useEffect, useState, useRef } from 'react'
import { StlViewer } from 'react-stl-viewer'
import MediaModal from '../sharedComponents/MediaModal'

interface IView360Stl {
  ImageUrl: string
  StlPath: string
  InitialScale?: number
  RotateButtonLabel: string
}

function View360Stl({ content }: { content: IView360Stl }) {
  const [open, setOpen] = useState(false)
  const [rotationZ, setRotationZ] = useState(0)
  const [positionX, setPositionX] = useState(0.5)
  const [scale, setScale] = useState(content.InitialScale || 0.3)
  const containerRef = useRef<HTMLDivElement>(null)
  const messageRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const handleMouseDown = () => {
      if (messageRef.current) {
        messageRef.current.style.display = 'none'
      }
    }

    const handleMouseUp = () => {
      if (messageRef.current) {
        messageRef.current.style.display = 'block'
      }
    }

    const container = containerRef.current
    if (container) {
      container.addEventListener('mousedown', handleMouseDown)
      container.addEventListener('mouseup', handleMouseUp)
    }

    return () => {
      if (container) {
        container.removeEventListener('mousedown', handleMouseDown)
        container.removeEventListener('mouseup', handleMouseUp)
      }
    }
  }, [])

  const onReset = () => {
    setRotationZ(0)
    setPositionX(0.5)
    setScale(content.InitialScale || 0.3)
  }

  const url = content.StlPath
  const style = {
    backgroundColor: '#F4F4F4',
    height: '100%',
    width: '100%',
  }

  const cameraProps = {
    initialPosition: {
      latitude: Math.PI / 8,
      longitude: -Math.PI / 8,
      distance: 500,
    },
  }
  const floorProps = {
    gridWidth: 1,
  }

  const modelProps = {
    positionX,
    positionY: floorProps.gridWidth / 2,
    rotationX: 0,
    rotationY: 0,
    rotationZ,
    scale,
    geometryProcessor: (geometry) => geometry,
  }

  const onError = () => setOpen(false)

  return (
    <div ref={containerRef}>
      <div className="relative">
        <img src={content.ImageUrl} className=" w-full object-cover " />
        <button
          onClick={() => {
            onReset()
            setOpen(true)
          }}
          className="btn btn-primary absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2"
        >
          360°
        </button>
      </div>

      {open && (
        <MediaModal setOpen={setOpen} fullScreen={true} fullBackground={true}>
          <div className="aspect-video w-full">
            <StlViewer
              style={style}
              url={url}
              floorProps={floorProps}
              cameraProps={cameraProps}
              modelProps={modelProps}
              onError={onError}
              orbitControls
              shadows
            />
          </div>
          <div
            className="absolute right-5 bottom-[90px] 
               md:right-6 md:bottom-[94px]
               xl:right-10 xl:bottom-[110px]
              "
          >
            <button
              onClick={() => setScale((prev) => prev + 0.05)}
              className="btn btn-circle-small btn-plus z-[55] "
            ></button>
          </div>
          <div
            className="absolute right-5 bottom-5
           md:right-6 md:bottom-6
           xl:right-10 xl:bottom-10
           "
          >
            <button
              onClick={() => setScale((prev) => prev - 0.05)}
              className="btn btn-circle-small btn-minus z-[55] "
            ></button>
          </div>
          <div
            className="absolute  w-max right-1/2 text-center text translate-x-1/2 bottom-1/3 bg-white rounded-full px-6 py-4 "
            ref={messageRef}
          >
            <span>{content.RotateButtonLabel}</span>
          </div>
        </MediaModal>
      )}
    </div>
  )
}

export default View360Stl
